export const OFFERS_CONFIG = {
  defaultCtaText: 'View offer',
  emptyStateText: 'No offers are available right now. Check back soon.',
  errorStateText: 'Could not load offers. Please try again.',
  featuredBadgeText: 'Featured',
  unknownTierLabel: 'Any tier',
  tierLabels: {
    bronze: 'Bronze',
    silver: 'Silver',
    gold: 'Gold',
  },
  logo: {
    heightClassName: 'h-10',
    containerClassName: 'h-10 w-24',
    imgClassName: 'h-full w-full object-contain',
    fallbackText: 'Logo',
  },
};

